export default {
  blueLogo: "#065C84",
  blueLight: "#f6f8fa",
};
